<template>
    <div class="form-field" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-readonly': readOnly}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <vue-timepicker v-model="internalValue" :format="formatTimepicker" :minute-interval="intervalDuration" hide-clear-button></vue-timepicker>
                <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','suffix','lang','required','readonly','maxlength','interval','format'],
        data: function () {
            return {
                internalValue: '',
                langClass:"",
                formatTimepicker: ""
            }
        },
        created: function() {
            this.internalValue = this.value ? this.value : "00:00";
            this.formatTimepicker = this.format ? this.format : "HH:mm:ss";
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
            this.intervalDuration = this.interval ? this.interval : 5
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                if( typeof this.internalValue === 'object' ){
                    let value = this.internalValue.HH ? this.internalValue.HH : '00' + ":";
                    value += this.internalValue.mm ? this.internalValue.mm : '00' + ":";
                    value += this.internalValue.ss ? this.internalValue.ss : '00';
                    this.$emit('input', value);
                }else{
                    this.$emit('input', this.internalValue);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Time.vue